module.exports = __webpack_public_path__ + "static/media/directwines_flow.cd971897.jpg";